/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export class BalancesDto {
	/** glitter balance of the actual user */
	balance: number;
	/** total nr of crispr parts */
	crisprParts = 0;
	/** total nr of glitter packages */
	glitterOffers = 0;
	/** total nr of live narwhals */
	narwhals = 0;
	/** nr of the active user\'s narwhals */
	swarm = 0;
}